import * as React from "react";

import { filterChoices } from "./../../common/services/Filters";
import SelectYear from "./../../common/containers/SelectYear";
import DrillableFilterLink from "./../../common/containers/DrillableFilterLink";
import MultiSelectCheckbox from "./../../common/containers/MultiSelectCheckbox";
import SelectAggReport from "./../containers/SelectAggReport";

export interface Props {
  onDrillDown: (sectionName: string) => void;
}

const Filters = ({ onDrillDown }: Props) => {
  const onDrillDownClick = (sectionName: string) => {
    onDrillDown(sectionName);
  };

  return (
    <React.Fragment>
      <div className="ds-l-row ">
        <div className="ds-l-col--12  screenOnly">
          <a
            href="/explore/failures/"
            className="ds-c-button ds-u-fill--background-inverse ds-u-color--white ds-u-font-weight--normal"
          >
            Reset Filter
          </a>
          {/*TODO: Use Router Link instead*/}
        </div>
        <div className="ds-l-col--12">
          <SelectAggReport />
        </div>
        <div className="ds-l-col--12">
          <DrillableFilterLink
            filterPanelDetailSectionName="Select State/Territories"
            filterName="selectedStatesAlpha"
            onClick={onDrillDownClick}
          />
        </div>
        <div className="ds-l-col--6 ds-u-margin-right--auto">
          <SelectYear
            filterName="startFailYear"
            label="Start Year"
            yearList={filterChoices["yearChoices"]}
          />
        </div>
        <div className="ds-l-col--6 ds-u-margin-left--auto">
          <SelectYear
            filterName="endFailYear"
            label="End Year"
            yearList={filterChoices["yearChoices"]}
          />
        </div>
        {/* TODO: Have MultiSelect Checkbox Title come in from RefData */}

        <div className="ds-l-col--12">
          <div className="printOnly">
            <h3>Insurance Fund</h3>
          </div>
          <MultiSelectCheckbox
            label="Insurance Fund"
            filterName="selectedInsuranceFunds"
            choices={filterChoices["selectedInsuranceFunds"]}
          />
        </div>
        <div className="ds-l-col--12">
          <div className="printOnly">
            <h3>Charter Type</h3>
          </div>
          <MultiSelectCheckbox
            label="Charter Type"
            filterName="selectedCharterTypes"
            choices={filterChoices["selectedCharterTypes"]}
          />
        </div>
        <div className="ds-l-col--12">
          <div className="printOnly">
            <h3>Transaction Type</h3>
          </div>
          <MultiSelectCheckbox
            label="Transaction Type"
            filterName="selectedTransactionTypes"
            choices={filterChoices["selectedTransactionTypes"]}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default Filters;
